import React, { useEffect } from 'react';
import * as PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getAPI } from 'store/apiReducer';
import { SelectControl } from '@design-system-etat/dsfr-react';
import usagerClientReducer from '../../../../store/usagerReducer';
import {
    API_GET_REFERENTIEL_PAYS,
    CONTEXT_GET_REFERENTIEL_PAYS,
} from '../../../../constants/apiUrls.constants';
import { formaterOptions } from '../../../../utils/utils';

const SelectPays = ({
    paysParDefaut,
    referentielPays,
    sansFrance,
    getApi,
    name,
    label,
    texteAide,
    placeholder,
    error,
    warning,
    valid,
    disabled,
    required,
    onChange,
    register,
    isLoading,
    ...otherProps
}) => {
    const getPays = () => {
        getApi(usagerClientReducer, API_GET_REFERENTIEL_PAYS, CONTEXT_GET_REFERENTIEL_PAYS);
    };

    useEffect(() => {
        if (isLoading === null && (!referentielPays || Object.keys(referentielPays).length === 0)) {
            getPays();
        }
    }, [referentielPays, getPays]);

    const getReferentielSansFrance = () => {
        const nouveauReferentiel = [];
        // eslint-disable-next-line array-callback-return
        referentielPays.map((element) => {
            if (element.libelle !== 'France') {
                nouveauReferentiel.push(element);
            }
        });
        return nouveauReferentiel;
    };

    const getReferentielPaysParDefaut = () => {
        const nouveauReferentiel = [];
        nouveauReferentiel.push(paysParDefaut);
        // eslint-disable-next-line array-callback-return
        referentielPays.map((element) => {
            if (element.libelle !== 'France') {
                nouveauReferentiel.push(element);
            }
        });
        return nouveauReferentiel;
    };

    const getOptions = () => {
        if (referentielPays) {
            let referentielOptions = referentielPays;
            if (sansFrance) {
                referentielOptions = getReferentielSansFrance();
            } else if (paysParDefaut) {
                referentielOptions = getReferentielPaysParDefaut();
            }
            return referentielOptions.map((element) => {
                return {
                    key: element.code,
                    value: element.id,
                    libelle: element.libelle,
                };
            });
        }
        return [];
    };

    return (
        <SelectControl
            name={name}
            label={label}
            texteAide={texteAide}
            placeholder={referentielPays ? placeholder : 'Chargement en cours...'}
            error={error}
            warning={warning}
            valid={valid}
            disabled={disabled}
            required={required}
            onChange={onChange}
            options={formaterOptions(getOptions())}
            {...register}
            {...otherProps}
        />
    );
};

SelectPays.propTypes = {
    name: PropTypes.string.isRequired,
    referentielPays: PropTypes.array,
    paysParDefaut: PropTypes.object,
    sansFrance: PropTypes.bool,
    getApi: PropTypes.func.isRequired,
    isLoading: PropTypes.bool,
    label: PropTypes.string,
    texteAide: PropTypes.string,
    required: PropTypes.bool,
    disabled: PropTypes.bool,
    placeholder: PropTypes.string,
    /** Fonction register de React Hook Form */
    register: PropTypes.shape({
        onChange: PropTypes.func.isRequired,
        onBlur: PropTypes.func.isRequired,
        name: PropTypes.string.isRequired,
        ref: PropTypes.any.isRequired,
    }),
    onChange: PropTypes.func,
    error: PropTypes.shape({
        message: PropTypes.string.isRequired,
    }),
    warning: PropTypes.shape({
        message: PropTypes.string.isRequired,
    }),
    valid: PropTypes.shape({
        message: PropTypes.string.isRequired,
    }),
};

SelectPays.defaultProps = {
    sansFrance: false,
    label: null,
    disabled: false,
    required: false,
    texteAide: null,
    placeholder: '-- Choisir une option --',
    onChange: null,
    isLoading: null,
    referentielPays: null,
};

export default connect(
    (state) => {
        const { isLoading, erreur, data, message } = state.referentiel.pays;
        return {
            isLoading,
            erreur,
            referentielPays: data,
            message,
        };
    },
    {
        getApi: getAPI,
    },
)(SelectPays);
